//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "wel",
  data: function data() {
    return {
      activeNames: ['1', '2', '3', '5'],
      logActiveNames: ['18'],
      tableData: [{
        date: '2016-05-02',
        name: '来福士',
        address: '上海市普陀区金沙江路 1518 弄',
        type: [{
          id: 1,
          name: '零件'
        }, {
          id: 2,
          name: '长期备货'
        }]
      }]
    };
  } // computed: {
  //   ...mapGetters(["userInfo"]),
  // },
  // methods: {
  //   handleChange(val) {
  //     window.console.log(val);
  //   }
  // },

};